<template>
  <div class="d-flex flex-column flex-lg-row min-vh-100 bg-light">
    <Sidebar
      :class="{ 'd-none d-lg-flex': !sidebarOpen }"
      @close-sidebar="sidebarOpen = false"
    />

    <div class="main-content">
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />

      <main class="container-fluid p-4">
        <!-- ERROR -->
        <div
          v-if="error"
          class="alert alert-danger alert-dismissible fade show"
        >
          {{ error }}

          <button
            type="button"
            class="btn-close"
            @click="error = null"
          ></button>
        </div>

        <!-- CONTENIDO -->
        <!--
          El módulo se dibuja de inmediato: encabezado, filtros y encabezado de
          la tabla. El estado de carga vive solo dentro del tbody, así al
          entrar o al cambiar de página no se vuelve a montar toda la pantalla.
        -->
        <div
          v-if="!permisos || permisos?.listar"
          class="medidas-container"
        >
          <div class="medidas-header">
            <div>
              <h2>Gestión de Medidas</h2>

              <p>
                Listado general de medidas registradas
              </p>
            </div>

            <!-- PERMISO CREAR -->
            <button
              v-if="permisos?.crear"
              type="button"
              class="btn-nuevo"
              @click="openAddModal"
            >
              Nueva Medida
            </button>
          </div>

          <!-- FILTROS (se consultan contra la base de datos) -->
          <div class="medidas-filtros">
            <div class="filtro-campo">
              <label>Nombre</label>

              <input
                v-model.trim="filtroNombre"
                type="text"
                placeholder="Ej. Kilogramo"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>Unidad SAT</label>

              <input
                v-model.trim="filtroUnidad"
                type="text"
                placeholder="Ej. kg"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado desde</label>

              <input
                v-model="filtroDesde"
                type="date"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado hasta</label>

              <input
                v-model="filtroHasta"
                type="date"
              />
            </div>

            <div class="filtro-acciones">
              <button
                type="button"
                class="btn-filtro btn-filtro-primario"
                :disabled="loading"
                @click="aplicarFiltros"
              >
                Buscar
              </button>

              <button
                type="button"
                class="btn-filtro"
                :disabled="loading"
                @click="limpiarFiltros"
              >
                Limpiar
              </button>
            </div>
          </div>

          <div class="medidas-content">
            <div class="table-responsive">
              <table
                class="medidas-table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Nombre Corto</th>
                    <th>Fecha de Creación</th>

                    <!-- OCULTAR COLUMNA ACCIONES -->
                    <th
                      v-if="
                        permisos?.actualizar ||
                        permisos?.eliminar
                      "
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <!-- CARGANDO: solo el cuerpo de la tabla -->
                  <tr v-if="loading">
                    <td
                      :colspan="totalColumnas"
                      class="text-center text-muted py-5"
                    >
                      <span
                        class="spinner-border spinner-border-sm me-2"
                      ></span>

                      Cargando medidas...
                    </td>
                  </tr>

                  <template v-else>
                    <tr
                      v-for="(medida, index) in Medidas"
                      :key="medida.id"
                    >
                      <td>{{ numeroFila(index) }}</td>
                      <td>{{ medida.nombre_largo }}</td>
                      <td>{{ medida.unidad_sat }}</td>

                      <td>
                        {{ fechaCreacion(medida) }}
                      </td>

                      <!-- ACCIONES -->
                      <td
                        v-if="
                          permisos?.actualizar ||
                          permisos?.eliminar
                        "
                      >
                        <!-- PERMISO ACTUALIZAR -->
                        <button
                          v-if="permisos?.actualizar"
                          type="button"
                          class="btn btn-sm btn-warning me-2"
                          @click="openEditModal(medida)"
                        >
                          <i class="bi bi-pencil"></i>
                        </button>

                        <!-- PERMISO ELIMINAR -->
                        <button
                          v-if="permisos?.eliminar"
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteMedida(medida.id)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <tr v-if="Medidas.length === 0">
                      <td
                        :colspan="totalColumnas"
                        class="text-center text-muted py-5"
                      >
                        {{
                          hayFiltros
                            ? 'Con esos filtros no hay resultados.'
                            : 'No hay medidas registradas'
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!--
              PAGINACIÓN: cada botón dispara una consulta nueva al API.
              El navegador solo conserva la página actual.
            -->
            <div class="tabla-paginacion">
              <small>
                Mostrando {{ Medidas.length }} de
                {{ meta.total }} &middot;
                Página {{ meta.current_page }} de
                {{ meta.last_page }}
              </small>

              <div class="paginacion-botones">
                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="loading || meta.current_page <= 1"
                  @click="irPagina(meta.current_page - 1)"
                >
                  &lsaquo; Anterior
                </button>

                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="
                    loading ||
                    meta.current_page >= meta.last_page
                  "
                  @click="irPagina(meta.current_page + 1)"
                >
                  Siguiente &rsaquo;
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- SIN PERMISO PARA LISTAR -->
        <div
          v-if="permisos && !permisos?.listar"
          class="alert alert-warning text-center"
        >
          No tienes permiso para ver las medidas.
        </div>
      </main>
    </div>

    <div
      v-if="sidebarOpen"
      class="sidebar-overlay d-lg-none"
      @click="sidebarOpen = false"
    ></div>

    <!-- MODAL CREAR/EDITAR -->
    <BaseModal
      v-model:visible="modalVisible"
      :title="modalTitle"
    >
      <div class="mb-3">
        <label class="form-label">
          Nombre Largo
        </label>

        <input
          v-model="MedidaNombreLargo"
          type="text"
          class="form-control"
          placeholder="Ingrese el nombre largo"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">
          Nombre Corto
        </label>

        <input
          v-model="MedidaNombreCorto"
          type="text"
          class="form-control"
          placeholder="Ingrese el nombre corto"
        />
      </div>

      <template #footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="modalVisible = false"
        >
          Cancelar
        </button>

        <!-- PERMISO SEGÚN CREAR O EDITAR -->
        <button
          v-if="
            editingId
              ? permisos?.actualizar
              : permisos?.crear
          "
          type="button"
          class="btn btn-primary"
          @click="saveMedida"
        >
          {{ editingId ? 'Actualizar' : 'Guardar' }}
        </button>
      </template>
    </BaseModal>

    <!-- CONFIRMACIÓN -->
    <ConfirmModal
      v-model:visible="confirmModalVisible"
      :message="confirmMessage"
      @confirmed="onConfirmDelete"
    />
  </div>
</template>

<script>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount
} from 'vue';

import api, {
  obtenerPermisosPorModulo
} from '@/services/api.js';

import Header from '@/components/HeaderVue.vue';
import Sidebar from '@/components/Sidebar.vue';
import BaseModal from '@/components/BaseModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import { useFormatters } from '@/composables/useFormatters.js';

export default {
  name: 'MedidaSViews',

  components: {
    Header,
    Sidebar,
    BaseModal,
    ConfirmModal
  },

  setup() {
    const sidebarOpen = ref(false);
    const Medidas = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const modalVisible = ref(false);
    const modalTitle = ref('');
    const MedidaNombreLargo = ref('');
    const MedidaNombreCorto = ref('');
    const editingId = ref(null);

    const confirmModalVisible = ref(false);
    const confirmMessage = ref('');
    const deletingId = ref(null);

    /*
     * null significa que los permisos aún no cargan.
     */
    const permisos = ref(null);

    const {
      formatDate
    } = useFormatters();
    /*
    |--------------------------------------------------------------------------
    | Filtros y paginación (se resuelven en el servidor)
    |--------------------------------------------------------------------------
    */
    const filtroNombre = ref('');
    const filtroUnidad = ref('');
    const filtroDesde = ref('');
    const filtroHasta = ref('');

    const pagina = ref(1);

    // El módulo trabaja de 5 en 5.
    const porPagina = 5;

    const meta = ref({
      total: 0,
      current_page: 1,
      per_page: porPagina,
      last_page: 1
    });

    /*
     * Identifica la petición en curso: si el usuario cambia de página o de
     * filtro antes de que responda la anterior, la respuesta vieja se descarta.
     */
    let peticionActual = 0;

    /*
     * Se separa de 'loading' para que guardar o eliminar no vacíe la tabla.
     */
    const guardando = ref(false);

    const hayFiltros = computed(() => {
      return !!(
        filtroNombre.value ||
        filtroUnidad.value ||
        filtroDesde.value ||
        filtroHasta.value
      );
    });

    const totalColumnas = computed(() => {
      return permisos.value?.actualizar ||
        permisos.value?.eliminar
        ? 5
        : 4;
    });

    const numeroFila = (index) => {
      const pag = meta.value.current_page || 1;

      return (pag - 1) * porPagina + index + 1;
    };

    const fechaCreacion = (registro) => {
      const valor =
        registro?.created_at ||
        registro?.updated_at;

      if (!valor) {
        return '-';
      }

      return formatDate(valor);
    };


    const permisoActivo = (valor) => {
      return (
        valor === true ||
        valor === 1 ||
        valor === '1' ||
        valor === 'true'
      );
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar permisos del módulo medida
    |--------------------------------------------------------------------------
    */
    const fetchPermisos = async () => {
      try {
        const respuesta =
          await obtenerPermisosPorModulo('medida');

        permisos.value = {
          listar: permisoActivo(respuesta?.listar),
          crear: permisoActivo(respuesta?.crear),
          actualizar: permisoActivo(
            respuesta?.actualizar
          ),
          eliminar: permisoActivo(
            respuesta?.eliminar
          )
        };
      } catch (e) {
        permisos.value = {
          listar: false,
          crear: false,
          actualizar: false,
          eliminar: false
        };

        error.value =
          'No fue posible cargar los permisos de medidas.';
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar medidas
    |--------------------------------------------------------------------------
    */
        const fetchMedidas = async () => {
      if (!permisos.value?.listar) {
        Medidas.value = [];
        return;
      }

      const idPeticion = ++peticionActual;

      loading.value = true;
      error.value = null;

      try {
        const res = await api.get('/getMedida', {
          params: {
            nombre: filtroNombre.value || undefined,
            unidad: filtroUnidad.value || undefined,
            desde: filtroDesde.value || undefined,
            hasta: filtroHasta.value || undefined,
            page: pagina.value,
            per_page: porPagina
          }
        });

        // Llegó tarde: ya se pidió otra página u otro filtro.
        if (idPeticion !== peticionActual) {
          return;
        }

        Medidas.value = res.data?.data || [];

        const metaRespuesta = res.data?.meta;

        if (metaRespuesta) {
          meta.value = metaRespuesta;
          pagina.value = metaRespuesta.current_page;
        } else {
          meta.value = {
            total: res.data?.total || 0,
            current_page: pagina.value,
            per_page: porPagina,
            last_page: 1
          };
        }
      } catch (e) {
        if (idPeticion !== peticionActual) {
          return;
        }

        Medidas.value = [];

        error.value =
          'Error al cargar las medidas: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        if (idPeticion === peticionActual) {
          loading.value = false;
        }
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Acciones de filtro y paginación
    |--------------------------------------------------------------------------
    | Todas vuelven a consultar la base de datos; nada se filtra en memoria.
    */
    const aplicarFiltros = () => {
      pagina.value = 1;
      fetchMedidas();
    };

    const limpiarFiltros = () => {
      filtroNombre.value = '';
      filtroUnidad.value = '';
      filtroDesde.value = '';
      filtroHasta.value = '';
      pagina.value = 1;

      fetchMedidas();
    };

    const irPagina = (n) => {
      if (
        n < 1 ||
        n > (meta.value.last_page || 1) ||
        n === meta.value.current_page
      ) {
        return;
      }

      pagina.value = n;
      fetchMedidas();
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir modal para crear
    |--------------------------------------------------------------------------
    */
    const openAddModal = () => {
      if (!permisos.value?.crear) {
        error.value =
          'No tienes permiso para crear medidas.';
        return;
      }

      modalTitle.value = 'Nueva Medida';
      MedidaNombreLargo.value = '';
      MedidaNombreCorto.value = '';
      editingId.value = null;
      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir modal para editar
    |--------------------------------------------------------------------------
    */
    const openEditModal = (medida) => {
      if (!permisos.value?.actualizar) {
        error.value =
          'No tienes permiso para actualizar medidas.';
        return;
      }

      modalTitle.value = 'Editar Medida';
      MedidaNombreLargo.value =
        medida.nombre_largo || '';

      MedidaNombreCorto.value =
        medida.unidad_sat || '';

      editingId.value = medida.id;
      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Guardar o actualizar medida
    |--------------------------------------------------------------------------
    */
    const saveMedida = async () => {
      if (
        editingId.value &&
        !permisos.value?.actualizar
      ) {
        error.value =
          'No tienes permiso para actualizar medidas.';
        return;
      }

      if (
        !editingId.value &&
        !permisos.value?.crear
      ) {
        error.value =
          'No tienes permiso para crear medidas.';
        return;
      }

      const nombreLargo =
        MedidaNombreLargo.value.trim();

      const nombreCorto =
        MedidaNombreCorto.value.trim();

      if (!nombreLargo || !nombreCorto) {
        error.value =
          'El nombre largo y el nombre corto son obligatorios.';
        return;
      }

      guardando.value = true;
      error.value = null;

      const datos = {
        nombre_largo: nombreLargo,
        unidad_sat: nombreCorto
      };

      try {
        if (editingId.value) {
          await api.put(
            `/medidas/${editingId.value}`,
            datos
          );
        } else {
          await api.post('/medidas', datos);
        }

        modalVisible.value = false;
        await fetchMedidas();
      } catch (e) {
        error.value =
          'Error al guardar la medida: ' +
          (e.response?.data?.message || e.message);
      } finally {
        guardando.value = false;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Solicitar eliminación
    |--------------------------------------------------------------------------
    */
    const deleteMedida = (id) => {
      if (!permisos.value?.eliminar) {
        error.value =
          'No tienes permiso para eliminar medidas.';
        return;
      }

      deletingId.value = id;

      confirmMessage.value =
        '¿Seguro que deseas eliminar esta medida?';

      confirmModalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Confirmar eliminación
    |--------------------------------------------------------------------------
    */
    const onConfirmDelete = async () => {
      if (
        !permisos.value?.eliminar ||
        !deletingId.value
      ) {
        confirmModalVisible.value = false;
        return;
      }

      guardando.value = true;
      error.value = null;

      try {
        await api.delete(
          `/medidas/${deletingId.value}`
        );

        await fetchMedidas();
      } catch (e) {
        error.value =
          'Error al eliminar la medida: ' +
          (e.response?.data?.message || e.message);
      } finally {
        guardando.value = false;
        deletingId.value = null;
        confirmModalVisible.value = false;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Inicialización
    |--------------------------------------------------------------------------
    */
    onMounted(async () => {
      await fetchPermisos();

      if (permisos.value?.listar) {
        await fetchMedidas();
      }
    });

    /*
    |--------------------------------------------------------------------------
    | Salir del módulo: no dejar datos en memoria
    |--------------------------------------------------------------------------
    | Se descarta el listado y se invalida cualquier petición en vuelo para que
    | su respuesta no reviva el estado ya desmontado.
    */
    onBeforeUnmount(() => {
      peticionActual++;

      Medidas.value = [];

      meta.value = {
        total: 0,
        current_page: 1,
        per_page: porPagina,
        last_page: 1
      };
    });

    return {
      sidebarOpen,
      Medidas,
      loading,
      error,
      modalVisible,
      modalTitle,
      MedidaNombreLargo,
      MedidaNombreCorto,
      editingId,
      confirmModalVisible,
      confirmMessage,
      formatDate,
      permisos,

      filtroNombre,
      filtroUnidad,
      filtroDesde,
      filtroHasta,
      meta,
      guardando,
      hayFiltros,
      totalColumnas,

      numeroFila,
      fechaCreacion,
      aplicarFiltros,
      limpiarFiltros,
      irPagina,

      openAddModal,
      openEditModal,
      saveMedida,
      deleteMedida,
      onConfirmDelete
    };
  }
};
</script>


<style scoped>
.main-content{
    flex:1;
    margin-top:60px;
    transition:margin-left .3s ease;
}

@media (min-width:992px){
    .main-content{
        margin-left:250px;
    }
}

.sidebar-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.5);
    z-index:1019;
}

main{
    min-height:calc(100vh - 60px);
}

.medidas-container{
    background:#fff;
    border-radius:24px;
    overflow:hidden;
    box-shadow:0 15px 40px rgba(0,0,0,.05);
    border:1px solid #edf0f5;
}

.medidas-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:28px;
    border-bottom:1px solid #edf0f5;
}

.medidas-header h2{
    font-size:24px;
    font-weight:700;
    margin:0;
    color:#111827;
}

.medidas-header p{
    margin-top:6px;
    color:#6b7280;
}

.btn-nuevo{
    background:#2563eb;
    color:#fff;
    border:none;
    border-radius:14px;
    padding:12px 22px;
    font-weight:600;
}

.medidas-content{
    padding:20px;
}

.medidas-table{
    width:100%;
    border-collapse:separate;
    border-spacing:0 12px;
}

.medidas-table thead th{
    color:#64748b;
    font-size:13px;
    text-transform:uppercase;
    font-weight:700;
    padding:0 20px 10px;
}

.medidas-table tbody tr{
    background:#f8fafc;
}

.medidas-table td{
    padding:18px 20px;
}

.medidas-table tbody tr td:first-child{
    border-radius:16px 0 0 16px;
}

.medidas-table tbody tr td:last-child{
    border-radius:0 16px 16px 0;
}

.btn-warning{
    border:none;
    border-radius:12px;
}

.btn-danger{
    border:none;
    border-radius:12px;
}


/* FILTROS */

.medidas-filtros{
  display:flex;
  flex-wrap:wrap;
  gap:16px;
  align-items:flex-end;
  padding:20px 28px 0;
}

.filtro-campo{
  display:flex;
  flex-direction:column;
  gap:6px;
}

.filtro-campo label{
  color:#64748b;
  font-size:12px;
  font-weight:700;
  text-transform:uppercase;
}

.filtro-campo input{
  border:1px solid #e2e8f0;
  border-radius:12px;
  padding:10px 14px;
  min-width:200px;
}

.filtro-campo input:focus{
  outline:none;
  border-color:#2563eb;
}

.filtro-acciones{
  display:flex;
  gap:10px;
}

.btn-filtro{
  border:1px solid #e2e8f0;
  background:white;
  color:#334155;
  padding:10px 18px;
  border-radius:12px;
  font-weight:600;
}

.btn-filtro:hover:not(:disabled){
  background:#f1f5f9;
}

.btn-filtro:disabled{
  opacity:.5;
}

.btn-filtro-primario{
  background:#2563eb;
  border-color:#2563eb;
  color:white;
}

.btn-filtro-primario:hover:not(:disabled){
  background:#1d4ed8;
}

/* PAGINACIÓN */

.tabla-paginacion{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:center;
  gap:12px;
  padding-top:16px;
  border-top:1px solid #edf0f5;
  color:#64748b;
}

.paginacion-botones{
  display:flex;
  gap:10px;
}

@media (max-width:768px){
  .medidas-filtros{
    padding:20px 20px 0;
  }

  .filtro-campo,
  .filtro-campo input{
    width:100%;
    min-width:0;
  }

  .filtro-acciones{
    width:100%;
  }

  .btn-filtro{
    flex:1;
  }
}

</style>
